// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-3PptW";
var _3 = "control-p6Ziw";
var _4 = "control__edit-3FBPP";
var _5 = "price-25vRr";
var _6 = "price__selected-2eqQH";
export { _1 as "__esModule", _2 as "root", _3 as "control", _4 as "control__edit", _5 as "price", _6 as "price__selected" }
export default { "__esModule": _1, "root": _2, "control": _3, "control__edit": _4, "price": _5, "price__selected": _6 }
